<template>
  <el-drawer
    :model-value="modelValue"
    :title="$t('消息通知')"
    direction="rtl"
    size="520px"
    append-to-body
    destroy-on-close
    class="message-drawer"
    @close="closeDrawer"
  >
    <div class="message-panel">
      <el-scrollbar class="message-scroll">
        <div v-if="messages.length" class="message-list">
          <div
            v-for="item in messages"
            :key="item.id"
            class="message-item"
            :class="{ read: item.read }"
          >
            <span class="message-dot"></span>
            <div class="message-content">
              <div class="message-title">{{ item.title }}</div>
              <div class="message-desc">{{ item.content }}</div>
              <div class="message-meta">{{ item.time }}</div>
              <div class="message-actions">
                <el-button size="small" @click="handleView(item)">
                  {{ $t("查看订单") }}
                </el-button>
                <el-button
                  size="small"
                  :disabled="item.read"
                  @click="markAsRead(item)"
                >
                  {{ item.read ? $t("已读") : $t("标记已读") }}
                </el-button>
              </div>
            </div>
          </div>
        </div>

        <el-empty v-else :description="$t('暂无消息')" />
      </el-scrollbar>
    </div>
  </el-drawer>
</template>

<script setup>
import { computed, ref, watch } from "vue";
import { useI18n } from "vue-i18n";

defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["update:modelValue", "unread-change"]);
const { t } = useI18n();

const messages = ref([
  // {
  //   id: 1,
  //   title: "订单 ORD-20260620-001 目的港延误",
  //   content: "您的订单因天气原因在洛杉矶港延误，预计推迟 2 天派送",
  //   time: "10分钟前",
  //   read: false,
  // },
  // {
  //   id: 2,
  //   title: "订单 ORD-20260620-001 目的港延误",
  //   content: "您的订单因天气原因在洛杉矶港延误，预计推迟 2 天派送",
  //   time: "32分钟前",
  //   read: false,
  // },
  // {
  //   id: 3,
  //   title: "订单 ORD-20260620-001 目的港延误",
  //   content: "您的订单因天气原因在洛杉矶港延误，预计推迟 2 天派送",
  //   time: "1小时前",
  //   read: false,
  // },
  // {
  //   id: 4,
  //   title: "订单 ORD-20260620-001 目的港延误",
  //   content: "您的订单因天气原因在洛杉矶港延误，预计推迟 2 天派送",
  //   time: "昨天 16:20",
  //   read: true,
  // },
]);

const unreadCount = computed(
  () => messages.value.filter((item) => !item.read).length
);

watch(
  unreadCount,
  (value) => {
    emit("unread-change", value);
  },
  { immediate: true }
);

const markAsRead = (message) => {
  message.read = true;
};

const closeDrawer = () => {
  emit("update:modelValue", false);
};
</script>

<style scoped lang="scss">
.message-panel {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
}

.message-scroll {
  flex: 1;
  min-height: 0;
}

.message-list {
  padding: 4px 4px 28px;
}

.message-item {
  position: relative;
  display: flex;
  gap: 12px;
  padding: 16px 0 18px;

  &.read {
    .message-dot {
      background: #d8dde5;
    }

    .message-title,
    .message-desc,
    .message-meta {
      color: var(--app-text-secondary-color);
    }
  }
}

.message-dot {
  flex: 0 0 8px;
  width: 8px;
  height: 8px;
  margin-top: 7px;
  background: #f04444;
  border-radius: 50%;
}

.message-content {
  min-width: 0;
}

.message-title {
  color: var(--app-text-color);
  font-size: var(--app-font-size);
  font-weight: 600;
  line-height: 22px;
}

.message-desc {
  margin-top: 4px;
  color: var(--app-text-secondary-color);
  font-size: var(--el-font-size-small);
  line-height: 20px;
}

.message-meta {
  margin-top: 4px;
  color: var(--app-text-secondary-color);
  font-size: var(--el-font-size-extra-small);
}

.message-actions {
  display: flex;
  gap: 10px;
  margin-top: 12px;
}

:deep(.el-drawer__body) {
  min-height: 0;
}
</style>
